export default "__VITE_ASSET__CDY4aeIq__"